import { useEffect, useState } from "react";
import { getVerticalStacks, getJobTitles, getTerritories } from "./api";

/**
 * StackPickerPopup - the "browse the roles" rectangles.
 *
 * Extracted from GatewayPage 2026-09-18 so the SAME popup can open in two
 * places:
 *   1. the Gateway's Compensation tile (the 18-Sep agreed two-step), and
 *   2. the Comp page itself, on any arrival where the session has no
 *      vertical chosen yet - entering through the Job Matching Agent tile
 *      and then clicking Comp in the rail used to land on unfiltered
 *      tables with no popup at all.
 *
 * Styling stays in GatewayPage.css (gw-* classes) - one set of rules, both
 * mount points look identical.
 */
export default function StackPickerPopup({ onPick, onClose, onSkip, skipLabel }) {
  const [stacks, setStacks] = useState([]);
  const [roleCounts, setRoleCounts] = useState({});
  const [territoryCount, setTerritoryCount] = useState(null);

  useEffect(() => {
    Promise.all([getVerticalStacks(), getJobTitles(), getTerritories()])
      .then(([verticals, jobTitles, territories]) => {
        setStacks((verticals || []).filter((v) => v.is_active));
        const counts = {};
        (jobTitles || []).forEach((j) => {
          if (j.vertical_stack_id != null) counts[j.vertical_stack_id] = (counts[j.vertical_stack_id] || 0) + 1;
        });
        setRoleCounts(counts);
        setTerritoryCount((territories || []).length || null);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="gw-overlay" onClick={onClose} role="presentation">
      <div className="gw-popup" role="dialog" aria-label="Browse the roles" onClick={(e) => e.stopPropagation()}>
        <div className="gw-popup-head">
          <div className="gw-popup-title">Browse the roles</div>
          <button type="button" className="gw-popup-close" aria-label="Close" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 6l12 12M18 6L6 18" /></svg>
          </button>
        </div>
        <div className="gw-popup-sub">Pick a vertical - compensation opens filtered to it.</div>
        <div className="gw-stack-grid">
          {stacks.map((s) => (
            <button key={s.id} type="button" className="gw-stack-card" onClick={() => onPick(s.id)}>
              <div className="gw-stack-name">{s.name}</div>
              <div className="gw-stack-meta">
                {roleCounts[s.id] || 0} roles{territoryCount ? ` · ${territoryCount} territories` : ""}
              </div>
            </button>
          ))}
          {stacks.length === 0 && <div className="gw-popup-sub">Loading verticals…</div>}
        </div>
        <button type="button" className="gw-skip" onClick={onSkip}>
          {skipLabel || "Skip - open Compensation unfiltered →"}
        </button>
      </div>
    </div>
  );
}
